import { AnimatePresence } from "framer-motion";
import ListItem from "./ListItem";

import { getEnabledOptions } from "../../utils";

function OrderTable(props) {
  const { saleList, ressalenum, order, activeTable } = props;
  const data = getEnabledOptions(props, "dintablelist");

  return (
    <div className="bg-white py-2 px-1 rounded-md mb-3 grow h-full flex flex-col">
      <div className="relative h-full mt-2">
        <div className="px-2 absolute top-0 bottom-0 overflow-y-auto w-full">
          <AnimatePresence>
            {saleList.map((item, i) => (
              <ListItem
                item={item}
                key={i}
                i={i}
                {...props}
                activeProduct={props.activeProduct}
                setActiveProduct={props.setActiveProduct}
              />
            ))}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}

export default OrderTable;
